import * as React from 'react'
import { Block, Text } from '$views/components'

interface Props {
  adult: boolean
  child: boolean
  extra: boolean
}

export const CareType: React.FC<Props> = ({ adult, child, extra }) => {
  return (
    <Block>
      <Text as="span" menu color={child ? 'darkGrey' : 'grey'}>
        Niños
      </Text>
      <Text as="span" menu color="grey">
        {' '}
        |{' '}
      </Text>
      <Text as="span" menu color={adult ? 'darkGrey' : 'grey'}>
        Mayores
      </Text>
      <Text as="span" menu color="grey">
        {' '}
        |{' '}
      </Text>
      <Text as="span" menu color={extra ? 'darkGrey' : 'grey'}>
        Hogar
      </Text>
    </Block>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/CareType/CareType.tsx